import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  IFrameAppRequest,
  IFrameContactRequest,
  IFrameConversationRequest,
  IFrameMethod,
  IFrameOpenAIRequest,
  IFrameRequest,
  IFrameWindowRequest
} from '@intheloop/loop-integration';
import { OpenAiHelper } from '@shared/services/integrations/helper/open-ai-helper';
import { IFrameRequestHandlerI } from '@shared/services/integrations/iframe-request-handler.interface';
import { ContactHelper } from '@shared/services/integrations/helper/contact-helper';
import { ConversationHelper } from '@shared/services/integrations/helper/conversation-helper';
import { AuthHelper } from '@shared/services/integrations/helper/auth-helper';
import { AppHelper } from '@shared/services/integrations/helper/app-helper';
import { IframeWindowHelper } from '@shared/services/integrations/helper/iframe-window-helper';

@Injectable()
export class IntegrationMethodsHelper implements IFrameRequestHandlerI {
  constructor(
    private _openAiHelper: OpenAiHelper,
    private _contactHelper: ContactHelper,
    private _conversationHelper: ConversationHelper,
    private _appHelper: AppHelper,
    private _authHelper: AuthHelper,
    private iframeWindowHelper: IframeWindowHelper
  ) {}

  handleRequest(request: IFrameRequest, integrationId: string): Observable<any> {
    switch (true) {
      case request.$type === IFrameOpenAIRequest.type:
        return this._openAiHelper.handleRequest(request as IFrameOpenAIRequest, integrationId);
      case request.$type === IFrameContactRequest.type:
        return this._contactHelper.handleRequest(request as IFrameContactRequest, integrationId);
      case request.$type === IFrameConversationRequest.type:
        return this._conversationHelper.handleRequest(request as IFrameConversationRequest, integrationId);
      case request.$type === IFrameAppRequest.type:
        return this._appHelper.handleRequest(request as IFrameAppRequest, integrationId);
      case request.$type === IFrameWindowRequest.type:
        return this.iframeWindowHelper.handleRequest(request as IFrameWindowRequest, integrationId);
      case request.$type === IFrameRequest.type:
        return this.handleBasicRequest(request, integrationId);
    }
    return of(undefined);
  }

  private handleBasicRequest(request: IFrameRequest, integrationId: string): Observable<any> {
    switch (request.method) {
      case IFrameMethod.GET_SHORT_LIVED_TOKEN:
        return this._authHelper.handleRequest(request, integrationId);
      /**
       * The library may send this one as a plain request instead of an `IFrameConversationRequest`,
       * so it is routed to the conversation helper from here too.
       */
      case IFrameMethod.CREATE_TOPICAL_CHAT:
        return this._conversationHelper.handleRequest(request as IFrameConversationRequest, integrationId);
    }
    return of(undefined);
  }
}
